package com.milta.core.localization.translations.en

import com.milta.core.localization.SettingsStrings

internal val Settings = SettingsStrings(
    profileSectionTitle = "ORGANISATION PROFILE",
    profileNameLabel = "Organisation name",
    languageSectionTitle = "INTERFACE LANGUAGE",
    languageSearchPlaceholder = "Search for a language...",
    languageMoreAvailable = "%d more languages available",
    languageErrorGeneric = "An error occurred. Please try again.",
    subscriptionSectionTitle = "SUBSCRIPTION",
    subscriptionPlanLabel = "Plan",
    subscriptionBillingLabel = "Billing",
    subscriptionRenewalLabel = "Next renewal",
    subscriptionBillingMonthly = "Monthly",
    subscriptionBillingAnnual = "Annual",
    subscriptionPlanOrganisationLabel = "Organisation (Manager + team)",
    subscriptionPriceSuffix = "excl. VAT / month",
    subscriptionUnavailable = "Unavailable",
    deleteSectionTitle = "Delete the organisation",
    deleteWarning = "This action is permanent and irreversible.",
    deleteDescription = "Routes and proof-of-delivery records will be deleted. Driver accounts will be dissociated from the organisation, but never deleted.",
    deleteConfirmLabel = "To confirm, enter the organisation's name",
    deleteButton = "Delete permanently",
    deleteFinalDialogTitle = "Confirm permanent deletion?",
    deleteFinalDialogMessage = "This action cannot be undone. The organisation, its routes and proof-of-delivery records will be permanently deleted.",
    deleteErrorGeneric = "An error occurred. Please try again.",
    legalSectionTitle = "LEGAL NOTICES",
    legalTermsLabel = "Terms of Use",
    legalPrivacyLabel = "Privacy & GDPR",
)
